var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vwc-circular-progress", {
    attrs: {
      id: _vm.id,
      indeterminate: _vm.indeterminate,
      closed: _vm.closed,
      progress: _vm.progress,
      density: _vm.density,
      "aria-label": _vm.ariaLabel,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }